export default "https://legacy.eskolare-development.com/images/families-feature-three.png";